export enum PullActionType {
  INTERVAL = 1,
  HOME_POPUP = 2,
  HOME_INTERNATIONAL = 3,
  PRODUCT_DETAIL = 4,
  PROFILE = 5,
  SUBSCRIPTION = 6
}

export interface PullMessageResponse {
  title: string;
  title_color: string;
  body: string;
  body_color: string;
  image: string;
  sound: any;
  android_channel_id: any;
  boxes: Box[];
  logs: Logs;
  action_type: PullActionType;
}

export interface Box {
  id: number;
  box_type: PullBoxType;
  priority: number;
  text: string;
  text_color: string | null;
  box_color: string | null;
  link: string;
}

export enum PullBoxType {
  TEXT = 1,
  BUTTON = 2,
  INPUT = 3,
  IMAGE = 4
}

interface Logs {
  tags: string[];
  service_uuid: string;
  config_id: number;
  box_id: string;
  box_input: string; // value of button or input  OR  image alt
  is_cancelled: "true" | "false";
  event?: PullEventType;
  dg_id: string;
}

export type PullEventType = "CALL_TO_ACTION_CLICKED" | "DISMISS_BUTTON_CLICKED";
